<template>
  <div class="modal-content">
    <div
      class="modal-header bg-light justify-content-between align-items-center px-2 py-1"
      v-if="exerciseType == 11 || exerciseType == 13"
    >
      <div class="flex-grow-1 w-0 text-truncate">
        <ul class="list-inline mb-0 d-flex align-items-center text-truncate">
          <li class="list-inline-item mx-0 pr-0 pr-md-2 border-right">
            <button type="button" class="btn btn-light text-secondary d-flex" @click="onClose">
              <i class="pz-icon icon-cancel mr-1"></i>
              <span class="d-none d-md-inline-block">关闭</span>
            </button>
          </li>
          <li class="list-inline-item ml-2 ml-md-3 text-truncate">
            <h5 class="modal-title text-truncate f-xs-14">{{ title }}</h5>
          </li>
        </ul>
      </div>
      <!-- <h5 class="modal-title text-center">{{ title }}</h5> -->

      <ul class="list-inline mb-0">
        <li class="list-inline-item mx-0 mx-lg-2">
          <button
            type="button"
            class="btn btn-light text-secondary d-flex flex-column"
            @click="onResizeModal"
          >
            <i
              class="pz-icon"
              :class="`${isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'}`"
            ></i>
            <small class="d-none d-md-inline-block">全屏</small>
          </button>
        </li>
      </ul>
    </div>
    <div v-if="exerciseType == 13" class="modal-body p-0 bg-white h-100">
      <div
        class="h-100 d-flex flex-column justify-content-center align-items-center overflow-hidden"
      >
        <div class="mb-5">
          <!-- <img src="/img/StartOfTask2.39b756a7.png" /> -->
          <i class="pz-icon icon-check text-success" style="font-size: 150px"></i>
        </div>
        <div class="w-50 mb-5 text-center">
          <h2>交卷成功！</h2>
          <p class="text-black-50" v-if="AfterData.auto">考试时间结束, 系统已将您的试卷自动提交</p>
          <p class="text-black-50">您可以点击右下角[回顾试卷]按钮查看试卷哦</p>
        </div>
      </div>
    </div>
    <div class="modal-footer bg-light justify-content-between" v-if="exerciseType == 13">
      <div class="modal-footer-left"></div>
      <div class="modal-footer-right">
        <button type="button" class="btn btn-primary px-4" @click="onBackToPaper()">
          回顾试卷
        </button>
      </div>
    </div>

    <!-- <div class="modal-body bg-dark p-0" v-if="exerciseType == 12">
      <div class="text-white h-full d-flex flex-column justify-content-center align-items-center text-center">
        <div class="p-5 my-7" style="max-width:700px;">
          <div class="mb-6">
            <img src="../../../../assets/img/pz-class-v2/unittest.svg" width="150" />
          </div>
          <h2 class="mb-5 mb-lg-10">{{ AfterData.challengeResult ? '挑战成功' : '本次挑战失败了' }}</h2>
          <div class="row">
            <div class="col-6 col-md-3 mb-3">
              <h4 class="text-warning">{{ AfterData.totalQuestionsCount }}</h4>
              <span class="text-white-50">总题数</span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h4 class="text-info">{{ AfterData.correctQuestions }}</h4>
              <span class="text-white-50">对题数</span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h4 class="text-danger">{{ AfterData.incorrectQuestions }}</h4>
              <span class="text-white-50">错题数</span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h4 class="text-success">{{ Number.parseInt(AfterData.challengeAccuracy * 100) }}%</h4>
              <span class="text-white-50">正确率</span>
            </div>
          </div>
        </div>
      </div>
    </div>-->

    <div v-if="exerciseType == 12" class="modal-col bg-dark text-white">
      <div class="modal-header border-0">
        <button
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          class="btn btn-link text-white-50"
          @click="onClose"
        >
          <i class="pz-icon icon-close"></i>
        </button>
      </div>
      <div class="modal-body d-flex flex-column justify-content-center text-center">
        <!-- <ul class="list-inline px-7">
          <li class="list-inline-item mx-1" :key="`subject-left-id-${subject.subjectId}`" v-for="subject in AfterData.subjectsList">
            <i class="buliding-outline-icon" :class="`_b${subject.layerLevel}`"></i>
          </li>
        </ul>-->
        <div class="mb-6 d-none d-lg-block">
          <img src="https://resources.pzacademy.com/image/class-ui/unittest.svg" width="120" />
        </div>
        <div class="px-lg-5">
          <h1 class="mb-5">
            {{ AfterData.challengeResult ? '挑战成功' : '挑战失败' }}
            {{
              AfterData.upSkillsCount > 0
                ? `本次挑战 精通了${AfterData.upSkillsCount} 个知识点`
                : ``
            }}
          </h1>
          <p class="lead text-muted">
            共做对题数{{ AfterData.correctQuestions }}道、做错题数{{
              AfterData.incorrectQuestions
            }}道、正确率为{{ Number.parseInt(AfterData.challengeAccuracy * 100) }}%，{{
              AfterData.challengeResult ? '恭喜您，挑战成功' : '很遗憾，您本次挑战失败'
            }}！
          </p>

          <!-- <div class="row">
            <div class="col-6 col-md-3 mb-3">
              <h4 class="text-warning">{{ AfterData.totalQuestionsCount }}</h4>
              <span class="text-white-50">总题数</span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h4 class="text-info">{{ AfterData.correctQuestions }}</h4>
              <span class="text-white-50">对题数</span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h4 class="text-danger">{{ AfterData.incorrectQuestions }}</h4>
              <span class="text-white-50">错题数</span>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h4 class="text-success">{{ Number.parseInt(AfterData.challengeAccuracy * 100) }}%</h4>
              <span class="text-white-50">正确率</span>
            </div>
          </div>-->
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center d-none d-lg-block">
        <div
          v-if="!AfterData.challengeResult"
          class="border-top py-2 px-3 text-center text-white-50"
        >
          请复习一下本书的内容再进行挑战吧！
        </div>
      </div>
    </div>
    <div v-if="exerciseType == 12" class="modal-col">
      <div class="modal-body overflow-auto">
        <!-- <div> -->
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="text-black-50">挑战结果分析</h4>
          <span>共{{ AfterData.totalQuestionsCount }}道题</span>
        </div>
        <ul class="list-group list-group-flush mt-2">
          <li
            class="list-group-item px-0"
            :key="`subject-right-id-${reading.readingId}`"
            v-for="reading in AfterData.readingList"
          >
            <div class="row no-gutters">
              <div class="col-9">{{ reading.readingName }}</div>
              <div class="col-3 d-flex justify-content-end">
                <div style="width: 50px">
                  <i class="pz-icon icon-check-circle text-success mr-1"></i>
                  <span class="text-success">{{ reading.correctCount }}</span>
                </div>
                <!-- <span class="text-muted">｜</span> -->
                <div style="width: 50px">
                  <i class="pz-icon icon-cancel text-danger mr-1"></i>
                  <span class="text-danger">{{ reading.incorrectCount }}</span>
                </div>
                <!-- <i class="buliding-icon" :class="`_b${subject.beforeLayerLevel}`"></i>
                  <i class="material-icons trending-icon" :class="`_t${subject.layerStatus}`">trending_flat</i>
                <i class="buliding-icon" :class="`_b${subject.layerLevel}`"></i>-->
              </div>
            </div>
          </li>
        </ul>
        <!-- </div> -->
      </div>
      <div class="modal-footer align-items-center">
        <button type="button" class="btn btn-primary px-4" @click.prevent="review">回顾</button>
        <button type="button" class="btn btn-primary px-4" @click="onClose">关闭</button>
      </div>
    </div>

    <div
      v-if="exerciseType != 11 && exerciseType != 13 && exerciseType != 12"
      class="modal-col bg-dark text-white"
    >
      <div class="modal-header border-0 px-2 py-1">
        <button
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          class="btn btn-link text-white-50"
          @click="onClose"
        >
          <i class="pz-icon icon-close"></i>
        </button>
      </div>
      <div class="modal-body d-flex flex-column justify-content-center text-center">
        <ul class="list-inline px-5">
          <li
            class="list-inline-item mx-1"
            :key="`subject-left-id-${subject.subjectId}`"
            v-for="subject in AfterData.subjectsList"
          >
            <i class="buliding-outline-icon" :class="`_b${subject.layerLevel}`"></i>
          </li>
        </ul>
        <div class="px-5">
          <h3 class="font-weight-bold">本次练习{{ `影响了 ${AfterData.skillsCount} 个知识点` }}</h3>
          <p class="text-white-50" v-if="AfterData.lostPoint > 0">
            您失去了 {{ AfterData.lostPoint }} 个points
          </p>
          <p class="text-white-50" v-if="AfterData.gainPoints > 0">
            您获得了 {{ AfterData.gainPoints }} 个points
          </p>
          <!-- <p class="text-white-50">You got 5 questions correct</p> -->
        </div>
      </div>
      <div class="modal-footer justify-content-center border-0 d-none d-md-flex">
        <div class="mx-5 py-2 text-center text-white-50">刷题也会影响到知识点等级哦</div>
      </div>
    </div>
    <div v-if="exerciseType != 11 && exerciseType != 13 && exerciseType != 12" class="modal-col">
      <div class="modal-body overflow-auto p-5">
        <div>
          <h4 class="text-black-50 mb-3">知识点变化</h4>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item d-flex flex-column px-0 border-0 mb-3"
              v-for="(book, bookIdx) in AfterData.books"
              :key="`book-idx-${bookIdx}`"
            >
              <div class="d-flex justify-content-between align-items-center border-bottom">
                <h6 class="font-weight-bold">{{ book.bookName }}</h6>
                <div class="ml-3 d-flex align-items-center mb-3">
                  <small
                    class="book-level _v1"
                    :class="[
                      `_v${
                        AfterData.courseLevelUpTo == 3
                          ? AfterData.courseLevelUpTo
                          : AfterData.courseLevelUpTo + 1
                      }`,
                      { _master: book.beforeBookLevel == 4 },
                    ]"
                  >
                    {{ book.beforeBookLevel == 4 ? '' : book.beforeBookLevel }}
                  </small>
                  <i
                    class="pz-icon icon-enter trending-icon"
                    :class="{
                      _t0: book.beforeBookLevel == book.bookLevelUpTo,
                      _t1: book.beforeBookLevel < book.bookLevelUpTo,
                      _t2: book.beforeBookLevel > book.bookLevelUpTo,
                    }"
                  ></i>
                  <small
                    class="book-level _v1"
                    :class="[
                      `_v${
                        AfterData.courseLevelUpTo == 3
                          ? AfterData.courseLevelUpTo
                          : AfterData.courseLevelUpTo + 1
                      }`,
                      { _master: book.bookLevelUpTo == 4 },
                    ]"
                  >
                    {{ book.bookLevelUpTo == 4 ? '' : book.bookLevelUpTo }}
                  </small>
                  <!-- <small class="book-level _v1">{{book.bookLevelUpTo}}</small> -->
                </div>
              </div>
              <template v-if="book.subjectsList.length">
                <ul class="list-group list-group-flush ml-4 first-border-top-0">
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center px-0"
                    :key="`subject-right-id-${subject.subjectId}`"
                    v-for="subject in book.subjectsList"
                  >
                    <span>{{ subject.subjectName }}</span>
                    <div class="ml-3 d-flex align-items-center">
                      <div class="text-center" style="width: 32px">
                        <i class="buliding-icon" :class="`_b${subject.beforeLayerLevel}`"></i>
                      </div>
                      <i
                        class="pz-icon icon-enter trending-icon"
                        :class="`_t${subject.layerStatus}`"
                      ></i>
                      <div class="text-center" style="width: 32px">
                        <i class="buliding-icon" :class="`_b${subject.layerLevel}`"></i>
                      </div>
                    </div>
                  </li>
                </ul>
              </template>
              <template v-else>
                <div class="alert bg-light mt-3 small">该科目已精通，答题不会影响知识点等级</div>
              </template>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer align-items-center d-none d-md-flex">
        <!-- <button type="button" class="btn btn-link">Re-take quiz</button> -->
        <button type="button" class="btn btn-primary px-4" @click="onClose">关闭</button>
      </div>
    </div>

    <div class="modal-body bg-dark p-0 overflow-hidden" v-if="exerciseType == 11">
      <div
        class="text-white text-center d-flex justify-content-center align-items-center flex-column h-100"
      >
        <div class="practice-overview">
          <h2>{{ message.heading }}</h2>
          <p>{{ message.content }}</p>
          <div class="buliding-overview" :class="`_v${AfterPracticeInfo.pointsReachLevel}`">
            <i
              class="buliding-outline-icon _lg"
              :class="`_b${AfterPracticeInfo.pointsReachLevel}`"
            ></i>
            <div class="buliding-group">
              <div class="_t _t4">
                <div class="buliding-line"></div>
                <div class="buliding-text">
                  <h6 class="text-white mb-0">精通 ({{ AfterPracticeInfo.totalPoints }}分)</h6>
                  <!-- <small class="text-white-50">需要全部做对{{ AfterPracticeInfo.questionsTotalCount }}道题</small> -->
                </div>
              </div>
              <div class="_t _t3">
                <div class="buliding-line"></div>
                <div class="buliding-text">
                  <h6 class="text-white mb-0">熟悉 ({{ AfterPracticeInfo.layer3Points }}分)</h6>
                  <!-- <small class="text-white-50">需要在{{ AfterPracticeInfo.questionsTotalCount }}道题中做对{{ AfterPracticeInfo.layer3QuestionCount }}道</small> -->
                </div>
              </div>
              <div class="_t _t2">
                <div class="buliding-line"></div>
                <div class="buliding-text">
                  <h6 class="text-white mb-0">初步了解 ({{ AfterPracticeInfo.layer2Points }}分)</h6>
                  <!-- <small class="text-white-50">需要在{{ AfterPracticeInfo.questionsTotalCount }}道题中做对{{ AfterPracticeInfo.layer2QuestionCount }}道</small> -->
                </div>
              </div>
              <div class="_t _t1">
                <div class="buliding-line"></div>
                <div class="buliding-text">
                  <h6 class="text-white mb-0">您在这里</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer bg-light justify-content-between" v-if="exerciseType == 11">
      <template>
        <div
          class="modal-footer-left"
          v-if="AfterPracticeInfo.currentPoints - BeforePracticeInfo.currentPoints > 0"
        >
          您获得了 {{ AfterPracticeInfo.currentPoints - BeforePracticeInfo.currentPoints }} points
        </div>
        <div
          class="modal-footer-left"
          v-if="AfterPracticeInfo.currentPoints - BeforePracticeInfo.currentPoints < 0"
        >
          您失去了
          {{ -(AfterPracticeInfo.currentPoints - BeforePracticeInfo.currentPoints) }} points
        </div>
        <div
          class="modal-footer-left"
          v-if="AfterPracticeInfo.currentPoints - BeforePracticeInfo.currentPoints == 0"
        ></div>
      </template>

      <div class="modal-footer-right" v-if="AfterPracticeInfo.pointsReachLevel == 4">
        <button type="button" class="btn btn-link mr-3" @click="onRetry">再试一次</button>
        <button type="button" class="btn btn-primary px-4" @click="onClose">关闭</button>
      </div>
      <div class="modal-footer-right" v-if="AfterPracticeInfo.pointsReachLevel < 4">
        <button type="button" class="btn btn-link mr-3" @click="onClose">关闭</button>
        <button type="button" class="btn btn-primary px-4" @click="onRetry">再试一次</button>
      </div>
    </div>

    <!-- <div class="modal-footer justify-content-between p-2 p-md-3" v-if="exerciseType == 12">
      <div class="modal-footer-left"></div>

      <div class="modal-footer-right">
        <button type="button" class="btn btn-primary py-2 px-5" @click="onClose">关闭</button>
      </div>
    </div>-->
  </div>
  <!-- </div> -->
</template>
<script>
export default {
  name: 'After',

  props: {
    isFullscreen: Boolean,
    onResizeModal: Function,
    title: String,
    onClose: {
      type: Function,
      default: () => {},
    },
    onRetry: {
      type: Function,
      default: () => {},
    },
    exerciseType: {
      type: Number,
      default: () => '',
    },

    AfterData: Object,

    onGetAfterData: {
      type: Function,
      default: () => {},
    },

    onBackToPaper: {
      type: Function,
      default: () => {},
    },

    setIsInReview: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    AfterPracticeInfo: function () {
      return this.AfterData.afterSubject;
    },

    BeforePracticeInfo: function () {
      return this.AfterData.beforeSubject;
    },

    message: function () {
      const before = this.BeforePracticeInfo;
      const after = this.AfterPracticeInfo;
      let heading = '';
      let content = '';
      if (after.pointsReachLevel > before.pointsReachLevel) {
        switch (after.pointsReachLevel) {
          case 0:
            heading = '再试一次!';
            content = `更多的练习能够让您更好的初步了解本知识点`;
            break;
          case 1:
            heading = '再试一次!';
            content = `更多的练习能够让您更好的初步了解本知识点`;
            break;
          case 2:
            heading = '恭喜您已经初步了解了本知识点!';
            content = `您已经获得了 ${after.currentPoints} 分. 再答获得 ${
              after.layer3Points - after.layer2Points
            } 分.可以熟悉本知识点!`;
            break;
          case 3:
            heading = '恭喜您已经熟悉了本知识点!';
            content = `您已经获得了 ${after.currentPoints} 分. 答对所有题就可以精通本知识点!`;
            break;
          case 4:
            heading = `恭喜您！您已经精通了本知识点`;
            content = '!';
            break;
          default:
            heading = '';
        }
        return {
          heading,
          content,
        };
      } else if (after.pointsReachLevel <= before.pointsReachLevel) {
        switch (after.pointsReachLevel) {
          case 0:
            heading = '再试一次!';
            content = `更多的练习能够让您更好的初步了解本知识点`;
            break;
          case 1:
            heading = '再试一次!';
            content = `更多的练习能够让您更好的初步了解本知识点`;
            break;
          case 2:
            heading = '更多的练习能够让您进步的更快!';
            content = `温馨提示!更多的练习能够让您熟悉本知识点!`;
            break;
          case 3:
            heading = '更多的练习能够让您进步的更快!';
            content = `温馨提示!更多的练习能够让您精通本知识点!`;
            break;
          case 4:
            heading = `恭喜您！您已经精通了本知识点!`;
            content = '下一步我们建议您去挑战本科目并获得更多的Points!';
            break;
          default:
            heading = '';
        }
        return {
          heading,
          content,
        };
      }
      return {
        heading,
        content,
      };
    },
  },

  methods: {
    review() {
      this.setIsInReview({ stepInReview: 'before' });
    },
  },
};
</script>
<style scoped lang="scss"></style>
